import { useContext } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Home, ArrowLeft } from "lucide-react";
import { SEO } from "@/components/SEO";
import { Link } from "wouter";
import { StaticContext } from "@/lib/static-context";

export default function NotFound() {
  const staticCtx = useContext(StaticContext);
  staticCtx.statusCode = 404;

  return (
    <div className="min-h-[80vh] w-full flex items-center justify-center px-4">
      <SEO title="404 - Page Not Found" noindex={true} />
      <Card className="w-full max-w-md border-border/50 bg-card/50 backdrop-blur">
        <CardContent className="pt-10 pb-10 text-center">
          <div className="flex justify-center mb-6">
            <div className="h-20 w-20 rounded-full bg-destructive/10 flex items-center justify-center">
              <AlertCircle className="h-10 w-10 text-destructive" />
            </div>
          </div>
          
          <h1 className="font-display text-3xl font-bold mb-4">404 - Page Not Found</h1>
          <p className="text-muted-foreground mb-10">
            The page you're looking for doesn't exist or has been moved. 
            If you believe this is an error, please contact support.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link href="/" className="inline-flex h-11 items-center justify-center rounded-md bg-primary px-6 text-sm font-medium text-primary-foreground shadow transition-transform hover:scale-105">
              <Home className="mr-2 h-4 w-4" /> Back to Home
            </Link>
            <button 
              onClick={() => window.history.back()} 
              className="inline-flex h-11 items-center justify-center rounded-md border border-input bg-background px-6 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground"
            >
              <ArrowLeft className="mr-2 h-4 w-4" /> Go Back
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
